$jq.namespace('MatchCore.UI.Site');
MatchCore.UI.Site.StillThere = function () {
    return true;
};
